"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var cov_1twv0c9tp4 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/styles.js";
  var hash = "8816f796cb24983efd4b7114be7e0d93da5d5611";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/styles.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 20
        },
        end: {
          line: 1,
          column: 23
        }
      },
      "1": {
        start: {
          line: 3,
          column: 15
        },
        end: {
          line: 34,
          column: 2
        }
      },
      "2": {
        start: {
          line: 3,
          column: 27
        },
        end: {
          line: 34,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 3,
            column: 27
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "8816f796cb24983efd4b7114be7e0d93da5d5611"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var drawerWidth = (cov_1twv0c9tp4.s[0]++, 360);
cov_1twv0c9tp4.s[1]++;

var styles = function styles(theme) {
  cov_1twv0c9tp4.f[0]++;
  cov_1twv0c9tp4.s[2]++;
  return {
    root: {
      flexGrow: 1
    },
    grow: {
      flexGrow: 1
    },
    hide: {
      display: 'none'
    },
    appBar: {},
    menuButton: {
      marginLeft: -12,
      marginRight: 20
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      zIndex: '10000'
    },
    drawerPaper: {
      width: drawerWidth
    },
    drawerHeader: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px'
    }, theme.mixins.toolbar, {
      justifyContent: 'flex-end'
    })
  };
};

var _default = styles;
exports.default = _default;